var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustryValueChain1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 115.801,
    height: 115.799,
    viewBox: "0 0 115.801 115.799",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12.3 68.18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.92,28.959a57.9,57.9,0,0,1-57.9,57.9,57.9,57.9,0,1,1,0-115.8,57.9,57.9,0,0,1,57.9,57.9",
    transform: "translate(70.181 -39.24)",
    fill: "#2d9f52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.092,7.633c.794-2.175.372-5.8-2.753-10.952C-1.776,1.837-2.188,5.462-1.386,7.639A3.009,3.009,0,0,0,1.357,9.818,3,3,0,0,0,4.092,7.633M2.319-6.166C6.837.555,7.4,5.462,6.311,8.447a5.3,5.3,0,0,1-4.954,3.729A5.313,5.313,0,0,1-3.6,8.453C-4.705,5.466-4.149.559.357-6.166l.98-1.462Z",
    transform: "translate(68.851 -30.948)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.648-6.108h2.369V-44.075H40.648Z",
    transform: "translate(28.367 24.122)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.816,6.354C4.628,4.047,2.729.932-2.271-2.435-2.939,3.551-1.8,7.012-.16,8.651a3.011,3.011,0,0,0,3.407.83A3,3,0,0,0,4.816,6.354M-2.573-5.436C4.348-1.222,6.919,3,7.177,6.168A5.31,5.31,0,0,1,4.238,11.63a5.3,5.3,0,0,1-6.06-1.306C-4.077,8.073-5.628,3.383-4.353-4.611l.276-1.739Z",
    transform: "translate(62.282 -18.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.569,4.126C5.5,2.073,2.536-.058-3.376-1.216-1.663,4.556.735,7.3,2.882,8.171a3.007,3.007,0,0,0,3.457-.554,3,3,0,0,0,.23-3.491m-11.4-7.991C3.188-2.675,7.2.212,8.668,3.035a5.3,5.3,0,0,1-.58,6.172A5.308,5.308,0,0,1,2,10.364C-.953,9.169-4.208,5.45-6.145-2.412l-.42-1.711Z",
    transform: "translate(60.343 -6.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.011,6.261C.269,3.09,2.84-1.129,9.757-5.343l1.5-.914.278,1.741c1.272,7.987-.278,12.68-2.529,14.933h0a5.306,5.306,0,0,1-6.064,1.3A5.3,5.3,0,0,1,.011,6.261m9.443-8.6c-5,3.367-6.9,6.48-7.082,8.789A3,3,0,0,0,3.939,9.574a3.006,3.006,0,0,0,3.4-.83h0c1.639-1.639,2.781-5.1,2.111-11.086",
    transform: "translate(70.935 -18.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.359,3.58C1.83.757,5.839-2.13,13.854-3.32l1.739-.258-.42,1.711C13.238,6,9.983,9.712,7.034,10.913A5.314,5.314,0,0,1,.939,9.752,5.3,5.3,0,0,1,.359,3.58M12.4-.671C6.489.487,3.53,2.618,2.458,4.673a3,3,0,0,0,.23,3.489,3.011,3.011,0,0,0,3.457.556C8.294,7.846,10.693,5.1,12.4-.671",
    transform: "translate(71.031 -7.033)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustryValueChain1);
export default __webpack_public_path__ + "static/media/industry-value-chain-1.dc8a338cfeb525ad35f76df849eeb952.svg";
export { ForwardRef as ReactComponent };